"use client";

import { useApp } from "@/store/appStore";
import { translate } from "@/lib/i18n";

// useT() -> t(key, vars?) bound to the current locale.
export function useT() {
  const locale = useApp((s) => s.locale);
  return (key: string, vars?: Record<string, string | number>) =>
    translate(locale, key, vars);
}
